/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import * as stagesBasicCase from "../Stages/StagesBasicCase";
import * as stagesCase from "../Stages/StagesCase";
import _ from "lodash";
import { translate } from "../Translations/translatorService";
import { getNextStage } from "../Product/ProductService/productService";
import { trafficValidators } from "./Traffic/trafficValidators";
import { trafficAccidentValidators } from "./TrafficAccident/trafficAccidentValidators";
import { divorceValidators } from "./Divorce/divorceValidators";
import { contractValidators } from "./Contract/contractValidators";
import { settlementValidators } from "./Settlement/settlementValidators";
import { dataLeakContractValidators } from "./DataLeakContract/dataleakContractValidators";
import { dataLeakRequiredFields } from "./DataLeakContract/dataLeakContractRequiredFields";
import { rentalContractRequiredFields } from "./RentalContract/rentalContractRequiredFields";
import { contractRequiredFields } from "./Contract/contractRequiredFields";
import { trafficRequiredFields } from "./Traffic/trafficRequiredFields";
import { trafficAccidentRequiredFields } from "./TrafficAccident/trafficAccidentRequiredFields";
import { rentalContractValidators } from "./RentalContract/rentalContractValidators";
import { generalCivilLawValidators } from "./GeneralCivilLaw/generalCivilLawValidators";
import { generalCivilLawRequiredFields } from "./GeneralCivilLaw/generalCivilLawRequiredFields";
import { employmentContractRequiredFields } from "./EmploymentContract/employmentContractRequiredFIelds";
import { employmentContractValidators } from "./EmploymentContract/employmentContractValidators";
import { ProductUnion } from "../../types/ProductUnion";
import { civilServiceLawRequiredFields } from "./CivilServiceLaw/civilServiceLawRequiredFields";
import { civilServiceLawValidators } from "./CivilServiceLaw/civilServiceLawValidators";
import { pendingCaseRequiredFields } from "./PendingCase/pendingCaseRequiredFields";
import { pendingCaseValidators } from "./PendingCase/pendingCaseValidators";
import { stageMetaDataDivorce } from "../Stages/StagesDivorce";

const basicCaseValidators = {
  [stagesBasicCase.STAGE_CREATED]: () => [],
  [stagesBasicCase.STAGE_DATA_COMPLETED]: () => [],
  [stagesCase.STAGE_IN_PROGRESS]: () => [],
  [stagesBasicCase.STAGE_COMPLETED]: () => [],
};

const statusChangeRequiredFields = {
  civilServiceLaw: civilServiceLawRequiredFields,
  employmentContract: employmentContractRequiredFields,
  eventContract: contractRequiredFields,
  familyLawCase: basicCaseValidators,
  generalCivilLaw: generalCivilLawRequiredFields,
  membershipContract: contractRequiredFields,
  otherContract: contractRequiredFields,
  providerContract: contractRequiredFields,
  pendingCase: pendingCaseRequiredFields,
  dataLeakContract: dataLeakRequiredFields,
  purchaseContract: contractRequiredFields,
  rentalContract: rentalContractRequiredFields,
  serviceContract: contractRequiredFields,
  settlement: settlementValidators,
  subscriptionContract: contractRequiredFields,
  traffic: trafficRequiredFields,
  trafficAccident: trafficAccidentRequiredFields,
  travelContract: contractRequiredFields,
  vehicleContract: contractRequiredFields,
};

const statusChangeValidators = {
  civilServiceLaw: civilServiceLawValidators,
  divorce: divorceValidators,
  employmentContract: employmentContractValidators,
  eventContract: contractValidators,
  familyLawCase: basicCaseValidators,
  generalCivilLaw: generalCivilLawValidators,
  membershipContract: contractValidators,
  otherContract: contractValidators,
  providerContract: contractValidators,
  pendingCase: pendingCaseValidators,
  dataLeakContract: dataLeakContractValidators,
  purchaseContract: contractValidators,
  rentalContract: rentalContractValidators,
  serviceContract: contractValidators,
  settlement: settlementValidators,
  subscriptionContract: contractValidators,
  traffic: trafficValidators,
  trafficAccident: trafficAccidentValidators,
  travelContract: contractValidators,
  vehicleContract: contractValidators,
};

export const getRequiredFields = <T extends ProductUnion = ProductUnion>(product: T, stageNumber?: number) => {
  const productClassName = product.productClassName;
  const nextStageNumber = stageNumber ?? getNextStage(product)?.stage; // by default, get the next stage, if no other stage is provided
  if (!productClassName || !nextStageNumber) {
    return [];
  }

  if (product.productClassName === "divorce") {
    const leadStatus = stageMetaDataDivorce[nextStageNumber].leadStatus;

    if (leadStatus === null) {
      return [];
    }

    return product.requiredFields[leadStatus];
  }

  // @ts-ignore
  const getRequiredFields = statusChangeRequiredFields[productClassName][nextStageNumber];
  if (!getRequiredFields) {
    return [];
  }
  return getRequiredFields(product, true);
};

export const validateFields = <T extends ProductUnion = ProductUnion>(
  requiredFields: Array<Extract<keyof T, string>>,
  productEntity: T
) => {
  let errorMessages: string[] = [];

  _.forEach(requiredFields, (requiredField) => {
    if (
      _.get(productEntity, requiredField) === undefined ||
      _.get(productEntity, requiredField) === null ||
      _.get(productEntity, requiredField) === ""
    ) {
      errorMessages.push(
        `Das Feld "${translate(productEntity.productClassName + "." + requiredField + ".label")}" muss ausgefüllt sein!`
      );
    }
  });
  return errorMessages;
};

export const validateStatusUpdate = <T extends ProductUnion = ProductUnion>(product: T, stage: number) => {
  // @ts-ignore
  return statusChangeValidators[product.productClassName][stage](product);
};

export default statusChangeValidators;
